<template>
  <b-col md="4" lg="3">
    <b-card
        :img-src="image.preview.image.url"
    >
      <b-button title="Löschen" style="position:absolute; right: 5px; bottom: 5px" variant="danger" :data-id="image.id" @click="deleteImage"><i class="fas fa-trash"></i></b-button>
      <b-spinner v-if="inProgress"></b-spinner>
    </b-card>
  </b-col>
</template>

<script>
  import products from "@/api/products";

  export default {
    props: ['image', 'productId',],
    data() {
      return {
        inProgress: false
      }
    },
    methods: {
      deleteImage() {
        this.inProgress = true;
        products.removeImage(this.image.id, this.productId).then(
            () => {
              this.$emit('image-deleted')
              this.inProgress = false;
            }
        );
      }
    }
  }
</script>
<style scoped lang="scss">
  .card {
    img {
      object-fit: contain;
      height: 180px;
    }
  }
</style>
